import React from 'react';
import { Award, Lightbulb, Users, DollarSign } from 'lucide-react';
import { companyInfo, whyChooseUs } from '../data/mock';

const iconMap = {
  Award,
  Lightbulb,
  Users,
  DollarSign
};

const About = () => {
  return (
    <section id="tentang" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        {/* About Content */}
        <div className="grid-two-column" style={{ marginBottom: '120px' }}>
          <div>
            <h2 className="heading-1" style={{ marginBottom: '24px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
              Tentang Annisa Wedding
            </h2>
            <div className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              <p style={{ marginBottom: '20px' }}>
                {companyInfo.description}
              </p>
              <p style={{ marginBottom: '20px' }}>
                Kami menghadirkan berbagai konsep pernikahan, mulai dari pernikahan adat Sunda dan Jawa yang kental dengan tradisi, hingga konsep modern minimalist dan outdoor garden yang elegan dan sophisticated.
              </p>
              <p>
                Dengan tim profesional yang berdedikasi, vendor pilihan berkualitas tinggi, dan perhatian terhadap setiap detail, kami memastikan pernikahan Anda berjalan sempurna dan meninggalkan kesan mendalam bagi semua yang hadir.
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="https://images.unsplash.com/photo-1643961517747-c7e7d0fea414?w=800&q=80"
              alt="Pernikahan Adat Indonesia - Annisa Wedding"
              style={{
                width: '100%',
                height: '500px',
                objectFit: 'cover',
                borderRadius: '0px',
                boxShadow: '0 10px 40px var(--gold-subtle)'
              }}
            />
          </div>
        </div>

        {/* Why Choose Us */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="heading-1" style={{ marginBottom: '16px', fontSize: 'clamp(24px, 4vw, 36px)' }}>
            Mengapa Memilih Annisa Wedding?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Kepercayaan ratusan pasangan adalah bukti komitmen kami terhadap kesempurnaan
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '32px'
        }}>
          {whyChooseUs.map((item) => {
            const IconComponent = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="hover-lift"
                style={{
                  background: 'var(--bg-secondary)',
                  padding: '40px 32px',
                  borderRadius: '0px',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '64px',
                  height: '64px',
                  background: 'var(--bg-primary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px'
                }}>
                  <IconComponent size={32} color="var(--text-primary)" />
                </div>
                <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                  {item.title}
                </h3>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
